import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addLicence,
  fetchAllLicence,
  removeLicence,
  updateLicence,
} from "../../apis/partner";
import { useDispatch } from "react-redux";
import {
  addLicenceData,
  removeLicenceData,
  updateLicenceData,
} from "../../store/Partner/partnerDataSlice";

export const useFetchAllLicence = (partnerId) => {
  return useQuery({
    queryKey: ["licence", partnerId],
    queryFn: () => fetchAllLicence(partnerId),
  });
};

export const useAddLicence = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: ({ partnerId, licence }) => addLicence(partnerId, licence),
    onSuccess: (newLicence, variables) => {
      console.log("Success!", newLicence);
      queryClient.refetchQueries(["licence", variables.partnerId]);
      dispatch(addLicenceData(newLicence));
    },
    onError: (error) => {
      console.error("Error", error);
    },
  });
};

export const useRemoveLicence = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: ({ partnerId, licenceId }) =>
      removeLicence(partnerId, licenceId),
    onSuccess: (deletedLicenceId) => {
      dispatch(removeLicenceData(deletedLicenceId));
    },
    onError: (error) => {
      console.error("Error", error);
    },
  });
};

export const useUpdateLicence = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: ({ licenceId, licence }) => updateLicence(licenceId, licence),
    onSuccess: (updatedLicence, variables) => {
      console.log("Update Success!", updatedLicence);
      queryClient.refetchQueries(["licence", variables.partnerId]);
      dispatch(updateLicenceData(updatedLicence));
    },
    onError: (error) => {
      console.error("Update Error", error);
    },
  });
};
